"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function video_hls(video) {
    if (video.src && video.src.includes('b-cdn')) {
        return video.src;
    }
    var domain = 'https://cdn.jwplayer.com';
    if (video.type === 'live') {
        return domain + "/live/events/" + video.external_id + ".m3u8";
    }
    return domain + "/manifests/" + video.external_id + ".m3u8?timestamp=" + Date.now();
}
var timer = null;
var status = '';
function usePolling(channel, video, setVideo, user) {
    react_1.useEffect(function () {
        if (timer) {
            clearInterval(timer);
        }
        timer = setInterval(function () {
            ra_fetch_1.Fetcher.api('backend').show('videos', {
                id: video.id,
                details: true,
                channel_id: channel.id,
                resource: 'VideoFull',
                viewer_id: user.id,
            }).then(function (response) {
                setVideo(response.data);
            });
        }, 15000);
        return function () { return clearInterval(timer); };
    }, [video.status]);
}
var messages = {
    ads: {
        title: 'Pre-roll wordt verwerkt',
        subtitle: 'deze is binnen enkele minuten beschikbaar',
    },
    vod: {
        title: 'Video wordt verwerkt',
        subtitle: 'deze is binnen enkele minuten beschikbaar',
    },
    live: {
        title: 'Start je encoder en begin met streamen',
        subtitle: 'na maximaal 60 sec verschijnt hier een preview',
    },
};
var Player = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.channel, channel = _f === void 0 ? {} : _f, autoplay = _a.autoplay, className = _a.className, hls = _a.hls, id = _a.id, video = _a.video, setVideo = _a.setVideo, state = _a.state, onLoaded = _a.onLoaded, user = _a.user, ads = _a.ads;
    var div_id = "jwplayer-player-" + id;
    var playable = video.status === 'published';
    status = video.status;
    var initPlayer = function (video) {
        var webVttUrl = process.env.NEXT_PUBLIC_STORYBOOK_SERVICE_MEDIA_URL + "/video_chapters/" + video.external_id + "/webvtt";
        var options = {
            playlist: [{
                    file: hls || video_hls(video),
                    mediaid: video.external_id,
                    image: video.thumbnail,
                    tracks: [{
                            file: webVttUrl,
                            kind: 'chapters',
                        }],
                }],
            skin: {
                url: process.env.NEXT_PUBLIC_STORYBOOK_CDN_URL + "/front-end/css/jwplayer.css",
                name: 'eyecons',
            },
            autostart: autoplay,
            liveTimeout: 0,
            cast: {},
        };
        if (ads && video.playout) {
            options.advertising = {
                client: 'googima',
                tag: video.playout,
                rules: {
                    frequency: 0,
                },
            };
        }
        jwplayer(div_id).setup(options);
        if (onLoaded) {
            jwplayer().on('play', onLoaded);
        }
    };
    react_1.useEffect(function () {
        if (playable) {
            initPlayer(video);
            return function cleanUp() {
                jwplayer().remove();
            };
        }
    }, [video.id, playable, video.status]);
    if (video.type === 'live' && setVideo && channel.id) {
        usePolling(channel, video, setVideo, user);
    }
    react_1.useEffect(function () {
        if (state === 'pause') {
            jwplayer().pause();
        }
        if (state === 'play') {
            jwplayer().play();
        }
    }, [state]);
    if (!playable) {
        return react_1.default.createElement("div", { className: 'storybook-players-player-draft' },
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'text-white' }, (_c = (_b = messages[video.type]) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : ''),
                react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-white font-thin' }, (_e = (_d = messages[video.type]) === null || _d === void 0 ? void 0 : _d.subtitle) !== null && _e !== void 0 ? _e : '')));
    }
    return react_1.default.createElement("div", { className: 'relative' },
        video.type === 'live' && react_1.default.createElement(storybook_1.Livestreams.Viewers, { viewers: video.viewers }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: className, id: div_id })));
};
exports.Player = Player;
exports.Player.propTypes = {
    autoplay: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    hls: prop_types_1.default.object,
    id: prop_types_1.default.string,
    onError: prop_types_1.default.func,
    video: prop_types_1.default.object,
    ads: prop_types_1.default.bool
};
exports.Player.defaultProps = {
    ads: false,
    autoplay: false,
    className: '',
    id: 'jwplayer-player',
    onError: function () {
    },
    video: {},
};
